module.exports = __webpack_public_path__ + "media/wrong_answer2.1002bc15.mp3";